<template>
    <div>
        <b-row v-for="(s, sk) of sections"
               v-if="s.items.filter(a => a.hidden === false).length > 0 && s.name === sec">
            <b-col>
                <h5 style="margin-bottom: 15px; margin-top: 30px">
                    {{ s.name.toUpperCase() }}
                </h5>
                <b-row v-for="(i, ik) in s.items" class="section-area row-item" v-if="!i.hidden">
                    <b-col md="1" class="change-value-button" @click="subAdd(sk, ik, 'sub')">
                            <span v-if="i.quantity > 0">
                                -
                            </span>
                    </b-col>
                    <b-col md="1" class="change-value-button" @click="subAdd(sk, ik, 'add')">
                        +
                    </b-col>
                    <b-col md="3">
                        <div v-if="i.quantity > 0">
                            <b-input v-model="i.quantity" @change="$emit('uc')"/>
                        </div>
                    </b-col>
                    <b-col>
                        <span v-if="i.quantity > 0" class="text-primary font-weight-bold">{{ i.name }}</span>
                        <span v-else>{{ i.name }}</span>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Vue from 'vue';
    export default {
        name: 'SectionItems',
        props: ['sec', 'sections'],
        created() {
        },
        methods: {
            subAdd(sk, ik, m) {
                this.$emit('sub-add', {
                    sk: sk, ik: ik, m: m
                });
            },
        },
    };
</script>

<style scoped>

</style>
